import { Component, EventEmitter, Output, Input, OnInit } from '@angular/core';
import { MatTableDataSource, MatCheckboxChange, MatSnackBar } from '@angular/material';
import { Imagen } from '../../../../interfaces/imagen';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs/Subscription';
import { PermisoService } from '../../../../providers/permiso.service';
import { ArchivoProducto } from '../../../../interfaces/archivo-producto';
import { ProductoService } from '../../../../providers/producto.service';

@Component({
  selector: 'app-ver-archivos-producto',
  templateUrl: './ver-archivos-producto.component.html',
  styleUrls: ['./ver-archivos-producto.component.scss']
})
export class VerArchivosProductoComponent implements OnInit {

  actualizarTablaTimeoutImagenes: any; // prevenir muchos llamados consecutivos al webserver
  flag_primera_carga_imagenes: boolean = true; // primera solicitud
  imagenes: Imagen[] = <Imagen[]>[];
  tablaImagenesColumnas = ["destacada", "ID", "imagen"];
  imagenesDataSource = new MatTableDataSource();
  getImagenProductoSuscripcion = new Subscription();
  cargandoImagenes: boolean = false;

  actualizarTablaTimeoutArchivos: any; // prevenir muchos llamados consecutivos al webserver
  flag_primera_carga_archivos: boolean = true; // primera solicitud
  archivos: ArchivoProducto[] = <ArchivoProducto[]>[];
  tablaArchivosColumnas = ["ID", "nombreWeb", "descargar"];
  archivosDataSource = new MatTableDataSource();
  getArchivosProductoSuscripcion = new Subscription();
  cargandoArchivos: boolean = false;

  IdProducto: number | string;
  @Input() acciones: boolean = true;
  @Output() formState = new EventEmitter(); // emite el estado del formulario
  @Output() onArchivoInput = new EventEmitter(); // emite el estado del formulario
  @Output() onCambiosGuardados = new EventEmitter(); // emite el estado del formulario

  constructor(
    private productoService: ProductoService,
    private _sanitizer: DomSanitizer,
    private permisoService: PermisoService,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    if (this.acciones) { // si solicitan mostrar acciones
      this.permisoService.tienePermiso('PRODUCTO-IMAGEN-ACCIONES').then(tienePermiso => { // si tiene permiso
        if (tienePermiso) {
          this.tablaImagenesColumnas.push('acciones');
        }
      });

      this.permisoService.tienePermiso('PRODUCTO-ARCHIVO-ACCIONES').then(tienePermiso => { // si tiene permiso
        if (tienePermiso) {
          this.tablaArchivosColumnas.push('acciones');
        }
      });
    }
  }

  onInput(): void {
    this.onArchivoInput.emit();
  }

  getSecureUrl(url) {
    return this._sanitizer.bypassSecurityTrustStyle(`url(${url})`);
  }

  actualizarTabla(): void {
    /* carga de imagenes */
    clearTimeout(this.actualizarTablaTimeoutImagenes);
    this.actualizarTablaTimeoutImagenes = setTimeout(() => {

      if (this.getImagenProductoSuscripcion && !this.getImagenProductoSuscripcion.closed) {
        this.getImagenProductoSuscripcion.unsubscribe();
      }

      // datos de las imagenes
      this.cargandoImagenes = true;
      this.imagenes = <Imagen[]>[];
      this.getImagenProductoSuscripcion = this.productoService
        .getImagenesProducto(
          {
            page: null,
            pageSize: null
          },
          {
            sort: 'fechaAlta',
            order: 'asc'
          },
          {
            IdProducto: this.IdProducto
          }
        )
        .subscribe(
          respuesta => {
            if (respuesta) {
              if (respuesta.estado == 1 && respuesta.data) {
                if (respuesta.data.fotos) {
                  respuesta.data.fotos.forEach((foto) => {
                    this.imagenes.push(<Imagen>{
                      IdImagen: foto.id,
                      destacada: !!+foto.destacada,
                      src: foto.link,
                      orden: +foto.orden
                    });
                  });
                }

                this.imagenesDataSource.data = this.imagenes;
              } else if (respuesta.estado != 1) {
                this.formState.emit({ // error al buscar datos
                  estado: respuesta.estado,
                  mensaje: respuesta.mensaje
                });
              }
            }

            this.cargandoImagenes = false;
          },
          error => {
            this.cargandoImagenes = false;

            this.formState.emit({ // error al buscar datos
              estado: 2,
              mensaje: error
            });
          }
        );
    }, (this.flag_primera_carga_imagenes ? 0 : 220));

    this.flag_primera_carga_imagenes = false;
    /* /carga de imagenes */

    /* carga de archivos */
    clearTimeout(this.actualizarTablaTimeoutArchivos);
    this.actualizarTablaTimeoutArchivos = setTimeout(() => {

      if (this.getArchivosProductoSuscripcion && !this.getArchivosProductoSuscripcion.closed) {
        this.getArchivosProductoSuscripcion.unsubscribe();
      }

      // datos de los archivos
      this.cargandoArchivos = true;
      this.archivos = <ArchivoProducto[]>[];
      this.getArchivosProductoSuscripcion = this.productoService
        .getArchivosProducto(
          {
            page: null,
            pageSize: null
          },
          {
            sort: 'fechaAlta',
            order: 'asc'
          },
          {
            IdProducto: this.IdProducto
          }
        )
        .subscribe(
          respuesta => {
            if (respuesta) {
              if (respuesta.estado == 1 && respuesta.data) {
                respuesta.data.archivos.forEach((archivo, index) => {
                  this.archivos.push(<ArchivoProducto>{
                    IdArchivo: archivo.id,
                    src: archivo.link,
                    nombreWeb: archivo.nombreWeb,
                    orden: +archivo.orden
                  });
                });
              } else if (respuesta.estado != 1) {
                this.formState.emit({ // error al buscar datos
                  estado: respuesta.estado,
                  mensaje: respuesta.mensaje
                });
              }
            }

            this.archivosDataSource.data = this.archivos;
            this.cargandoArchivos = false;
          },
          error => {
            this.cargandoArchivos = false;

            this.formState.emit({ // error al buscar datos
              estado: 2,
              mensaje: error
            });
          }
        );
    }, (this.flag_primera_carga_archivos ? 0 : 220));

    this.flag_primera_carga_archivos = false;
    /* /carga de archivos */
  }

  setImagenDestacada(event: MatCheckboxChange, nuevaImagenDestacada: Imagen): void {
    if (event.checked) {
      this.imagenes.forEach((imagen: Imagen) => {
        if (imagen.IdImagen == nuevaImagenDestacada.IdImagen) {
          imagen.destacada = true;
        } else {
          imagen.destacada = false;
        }
      });

      this.guardarDestacada();
    } else {
      event.source.checked = true;
    }
  }

  guardarDestacada(): void {
    if (this.imagenes.length > 0) {
      var destacada: Imagen = this.imagenes[0];
      this.imagenes.forEach((imagen: Imagen) => {
        if (imagen.destacada) {
          destacada = imagen;
          return;
        }
      });

      this.formState.emit({
        cargando: true
      });

      this.productoService
        .editarImagenesProducto(
          this.IdProducto,
          destacada.IdImagen
        )
        .subscribe(
          respuesta => {
            if (respuesta.estado == 1) {
              this.snackBar.open(respuesta.mensaje, 'OK', { duration: 2750 });
            }

            this.formState.emit({ // error al buscar datos
              estado: respuesta.estado,
              mensaje: respuesta.mensaje,
              cargando: false
            });
          },
          error => {
            this.formState.emit({ // error al buscar datos
              estado: 2,
              mensaje: error,
              cargando: false
            });
          }
        )
    }
  }

  ngOnDestroy() {
    if (this.getImagenProductoSuscripcion && !this.getImagenProductoSuscripcion.closed) {
      this.getImagenProductoSuscripcion.unsubscribe();
    }
  }
}
